var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomenGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "two women",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#1b2a2d",
    floodOpacity: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 38c-12 0-21 10-21 27v11c0 4 3 7 7 7h28c4 0 7-3 7-7V65c0-17-9-27-21-27z",
    fill: "#c05aa2",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 80V52",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 80V52",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 25c0-12 8-21 19-21s19 9 19 21c0 11-4 23-4 23H10S6 36 6 25z",
    fill: "#3a2620",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10c8 0 15 7 15 15 0 12-6 22-15 22S9 37 9 25c0-8 7-15 15-15z",
    fill: "#f1c27d",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25c5-1 10-5 13-11 5 7 13 9 21 10-1-12-8-19-18-19S8 13 8 25z",
    fill: "#3a2620",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 28,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 28,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 36c4 3 8 3 12 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 36c-11 0-20 9-20 26v11c0 4 3 7 7 7h26c4 0 7-3 7-7V62c0-17-9-26-20-26z",
    fill: "#4e9cc9",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 77V51",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 77V51",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 23c0-11 7-19 18-19 10 0 18 8 18 19 0 10-4 22-4 22H9S5 33 5 23z",
    fill: "#5a3529",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10c8 0 14 6 14 14 0 11-6 21-14 21S8 35 8 24c0-8 6-14 14-14z",
    fill: "#e6b36f",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24c5-1 9-5 12-10 5 6 12 8 20 9-1-11-7-18-17-18S7 13 7 24z",
    fill: "#5a3529",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 27,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 35c4 3 8 3 12 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenGroup);
export default __webpack_public_path__ + "static/media/women-group.765de648a8c626df79eeef75fe0a2cce.svg";
export { ForwardRef as ReactComponent };